import { LoadingButton } from "@mui/lab";
import { Autocomplete, Stack, TextField } from "@mui/material";
import { useSubscriptionEditTags } from "hooks/api/useSubscriptionEditTags";
import useNotifications from "hooks/useNotifications";
import { GlobalAppDataStorageService } from "infra/storage";
import { useState } from "react";

const toSortedIds = (tags) => tags.map((tag) => tag.id).sort((a, b) => a - b);

export const EditTagsForm = ({ subscriptionId, tags = [], onSuccess }) => {
    const tagOptions = GlobalAppDataStorageService.getSubscriptionTags();
    const { editTags, isLoading } = useSubscriptionEditTags();
    const { renderNotification, renderErrorNotification } = useNotifications();

    const [selectedTags, setSelectedTags] = useState(tags);

    const hasChanges =
        toSortedIds(selectedTags).join() !== toSortedIds(tags).join();

    const handleUpdateTags = async () => {
        const { isSaved, errorMessage } = await editTags({
            subscriptionId,
            tagIds: selectedTags.map((tag) => tag.id),
        });

        if (isSaved) {
            renderNotification("Subscription tags updated!");
            onSuccess?.();
        } else {
            renderErrorNotification(errorMessage);
        }
    };

    return (
        <Stack direction="row" gap={2} p={2} alignItems="flex-end">
            <Autocomplete
                multiple
                disableCloseOnSelect
                size="small"
                sx={{ width: 320 }}
                options={tagOptions}
                value={selectedTags}
                onChange={(_, nextTags) => setSelectedTags(nextTags)}
                getOptionLabel={(option) => option?.name ?? ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Subscription tags"
                    />
                )}
            />
            <LoadingButton
                loading={isLoading}
                disabled={!hasChanges}
                onClick={handleUpdateTags}
                size="small"
                color="primary"
                variant="contained"
                sx={{
                    px: "1rem",
                    whiteSpace: "nowrap",
                }}
            >
                Save Tags
            </LoadingButton>
        </Stack>
    );
};
export default EditTagsForm;
